import { useState } from "react";
import { useNavigate } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

import LogoutIcon from "@mui/icons-material/Logout";

import { useUser } from "../../contexts/UserContext";
import { logout } from "../../services/authService";

const LogoutButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { removeUser } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = async () => {
    try {
      setIsLoading(true);

      await logout();
    } catch (error) {
    } finally {
      removeUser();

      setIsLoading(false);

      navigate("/");
    }
  };

  return (
    <>
      <Tooltip title={t("common.actions.logout")} arrow>
        <IconButton
          color="#000"
          aria-label={t("common.actions.logout")}
          edge="end"
          onClick={handleLogout}
        >
          <LogoutIcon />
        </IconButton>
      </Tooltip>

      {isLoading && (
        <Backdrop
          aria-hidden="false"
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress size={40} />
        </Backdrop>
      )}
    </>
  );
};

export default LogoutButton;
